export default __webpack_public_path__ + "static/raw_materials-d70992b36120affdc7454b3fb90c47d6.jpeg";